module.exports = __webpack_public_path__ + "img/logo.947f09de.png";